<template>
    <div class='row'>
        <div class='col-sm-8 col-md-6 col-lg-4 mx-auto'>
            <div class='card card-signin my-5'>
                <div class='card-body'>
                    <h5 class='card-title text-center'><span :class='iconClass'></span> {{ title }}</h5>
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                user_manual_link: 'src/public/doc/Credicys - documentation utilisateur non connecte.pdf?' + Date.now()
            }
        },
        props: {
            title: String,
            iconClass: String
        },
        name: 'card'
    }
</script>

<style scoped>
    .card-signin {
        border: 0;
        margin-top: 0 !important;
        border-radius: 1rem;
        box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
    }

    .card-signin .card-title {
        margin-bottom: 2rem;
        font-weight: 300;
        font-size: 1.5rem;
    }

    .card-signin .card-body {
        padding: 2rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/auth/Card.vue